import { Injectable } from '@angular/core';

import moment from 'moment-timezone';

@Injectable({ providedIn: 'root' })
export class TimeService {
  public isAfterToday(date: string): boolean {
    return moment(date).isAfter(moment(), 'day');
  }

  public isBeforeToday(date: string): boolean {
    return this.isBeforeDay(date, this.format());
  }

  public isToday(date: string): boolean {
    return moment(date).isSame(moment(), 'day');
  }

  public isTomorrow(date: string): boolean {
    return moment(date).isSame(moment().add(1, 'day'), 'day');
  }

  public isDifferentDay(date1: string, date2: string): boolean {
    if (date1?.length === 0 && date2?.length === 0) {
      return false;
    }

    return !moment(date1).isSame(date2, 'day');
  }

  public isBeforeDay(testDay: string, targetDay: string): boolean {
    return moment(testDay).isBefore(targetDay, 'day');
  }

  public isSameDay(day1: string, day2: string): boolean {
    return moment(day1).isSame(day2, 'day');
  }

  public format(options?: { input?: moment.MomentInput; pattern?: string }): string {
    return moment(options?.input).format(options?.pattern);
  }

  public utcFormat(options?: {
    input?: moment.MomentInput;
    keepLocalTime?: boolean;
    pattern?: string;
  }): string {
    return moment(options?.input).utc(options?.keepLocalTime).format(options?.pattern);
  }

  public isAmountDaysAfter(sourceDate: string, destDate: string, amount: number): boolean {
    return moment(destDate).isAfter(moment(sourceDate).add(amount, 'day'));
  }

  public setCurrentTimeFor(date: moment.MomentInput): string {
    const now = moment();
    return moment(date)
      .set('hour', now.get('hour'))
      .set('minute', now.get('minute'))
      .set('second', now.get('second'))
      .format();
  }

  public setEndOfDayFor(date: moment.MomentInput): string {
    return moment(date).set('hour', 23).set('minute', 59).set('second', 59).format();
  }

  public isAmountHoursBefore(date: string, amount: number): boolean {
    return moment(date).isBefore(moment().subtract(amount, 'h'));
  }
}
